import Course from '@/content/models/course.model';
import { CORE_ROUTES } from '@/core/core.router';
import { UserPositionObserverMixin } from '@/core/mixins/user-position-observer.mixin';
import { COURSES_EVENTS } from '@/courses/values/courses-events.values';
import Component from 'vue-class-component';
import { Mixins, Watch } from 'vue-property-decorator';

@Component({
  components: {
    EdClassHeader: () => import(/* EdClassHeader */'./components/ed-class-header/ed-class-header.component.vue'),
    EdHomeworksCourseContainer: () => import(/* EdHomeworksCourseContainer */'@/homework/component/ed-homeworks-course-container/ed-homeworks-course-container.vue')
  }
})
export default class ClassesView extends Mixins(UserPositionObserverMixin) {

  public courseSelectedId: number = null;
  public coursesLoaded: number[] = [];

  get courses(): Course[] {
    const courses = this.$store.state.CourseStore.courses.content || [];
    return courses.filter(c => c.classId === this.classId);
  }

  get classId() {
    return Number(this.$route.params.id)
  }

  created() {
    if(!this.$route.params.id) {
      this.$router.push({ name: CORE_ROUTES.PRIVATE.HOME.NAME });
    }
  }

  courseSelected(courseId) {
    this.courseSelectedId = courseId;
    if(!this.coursesLoaded.includes(courseId)) {
      this.coursesLoaded.push(courseId);
    }

    const course = this.courses.find( course => course.id == this.courseSelectedId );
    const sectionId = course.viewer.sectionSelected?.sectionId;
    this.$edEventBus.$emit(COURSES_EVENTS.COURSE_SELECTED, {sectionId, classId:this.classId, courseId});
  }

  getIsCourseLoaded(courseId) {
    return this.coursesLoaded.includes(courseId);
  }

  beforeDestroy() {
    this.$Courses.Store.setCourses([]);
  }

  @Watch('classId')
  resetCourses() {
    if(!this.classId) {
      this.$router.push({ name: CORE_ROUTES.PRIVATE.HOME.NAME });
    }
    this.$Courses.Store.setCourses([]);
  }
}
